import React from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { connect } from "react-redux";

import "react-dates/initialize";
import 'react-dates/lib/css/_datepicker.css';

import { SingleDatePicker, DayPickerSingleDateController } from "react-dates";

import { commonErr } from "../../common/errors";
import { formatTime } from "../../common/common";
import {START_DATE, HORIZONTAL_ORIENTATION } from "../../../constant/constant";

import {
	getEndDatewd
} from "../../common/wdfunction";


class OptionalDate extends React.Component { 

	constructor(props) {
		super(props)
		this.state = {

			focusedInput: null,
			isDropdownST: false,
			isDropdownET: false
		}
	}

	componentDidMount() {
        this.setState({
			startDate: this.props.startDate,
			endDate: this.props.endDate
		})
	
	
	}


	componentDidUpdate(preProps) {		
		

	}

	onHandleDropdown = (name) => {
		this.setState({
			[`${name}`]: true,
		});
	}

	onCloseDropdown = (name) => {
		this.setState({
			[`${name}`]: false,
		});
	}

    onStartDateChange = (date) => {

		this.setState({
			startDate: date,
		})
		this.props.onDateChange(date);
	};


     renderAvailDayContents = (day) => {
        
        return (
          <span className="holiday-dates">{moment(day).format("D")}</span>
        );
      };
    
	onFocusChange = (focused) => {

      
		this.setState({
			// Force the focusedInput to always be truthy so that dates are always selectable
			focused: focused.focused,
		  });
	}

    onFocusEDChange = (focused) => {

       
		this.setState({
			// Force the focusedInput to always be truthy so that dates are always selectable
			focusedED: focused.focused,
		  });
	}

	isOutsideRange = (day) => {
		const { dayAvailable } = this.props;
		return day.isBefore(moment().add(dayAvailable, 'days'));
	}


    closeBox = () => {
        this.props.hideModal()
    }

	searchCar = () => {
		// const { filter } = this.props;
		// this.props.searchCar(filter);
		this.props.hideModal()
	}

	toggleDurationTimeBox = (isSelectHour) => {
		// const { isSelectHour } = this.state;
		this.props.toggleDurationTimeBox(isSelectHour)
		
	};

	onSelectHourChange = (e) => {
		this.props.onSelectHourChange(e);
	};


    render() {
		const { show, finding, isMCalendar, dayAvailable}  = this.props; 
		const { endDate, startDate, focused} = this.state;
	
		const defaultProps = {

			// initialStartDate: moment(),
			// initialEndDate: moment().add(1, "days"),

			// day presentation and interaction related props
			minimumNights: 1,
			isDayBlocked: () => false,
			isDayHighlighted: () => false,
			enableOutsideDays: false,
			daysViolatingMinNightsCanBeClicked: false,
		  
			// calendar presentation and interaction related props
			orientation: HORIZONTAL_ORIENTATION,
			verticalHeight: undefined,
			withPortal: false,
		
			numberOfMonths: 2,
			onOutsideClick() {},
			keepOpenOnDateSelect: false,
		
			isRTL: false,
			renderMonthText: null,
			renderMonthElement: null,
			renderKeyboardShortcutsButton: undefined,
			renderKeyboardShortcutsPanel: undefined,
		  
			// navigation related props
			navPrev: null,
			navNext: null,
			renderNavPrevButton: null,
			renderNavNextButton: null,
		
		  
			// internationalization
			monthFormat: 'MMMM YYYY',
		}

        return (
    <Modal
          show={show}
          onHide={this.closeBox}
          dialogClassName="modal-m modal-dialog modal-fix modal-search has-footer">
          <Modal.Header closeButton={true} closeLabel={""}>
           		<h5>Thời gian</h5>
          </Modal.Header>
          <Modal.Body>
              <div className="modal-confirm-body">
			  			{!isMCalendar ? 
						  	<DayPickerSingleDateController
								{...defaultProps}
								onDateChange={(date) => { this.onStartDateChange(date)}}
								onFocusChange={this.onFocusChange}
								focused={focused || START_DATE}
								date={startDate}
								isOutsideRange={this.isOutsideRange}
								hideKeyboardShortcutsPanel={true}
							/> 
							: 
							<div style={{height: '320px'}} >
								<DayPickerSingleDateController 
									{...defaultProps}
									onDateChange={(date) => { this.onStartDateChange(date)}}
									onFocusChange={this.onFocusChange}
									focused={focused || START_DATE}
									date={startDate}
									isOutsideRange={this.isOutsideRange}
									orientation="vertical"
									numberOfMonths={3}
									verticalHeight={500}
									hideKeyboardShortcutsPanel={true}
								/>
							</div>}
					</div>

          </Modal.Body>
          <Modal.Footer>
				<div className="info-time"> 
					<div className="info-time__item">
						
					</div>
					<div className="wrap-btn">
						<a className="btn btn--s btn-primary" onClick={finding ? this.searchCar : this.closeBox} >Tiếp tục</a>
					</div>
				</div>
			</Modal.Footer>
      	</Modal>
        )
    }
}


    export default OptionalDate